module.exports = __webpack_public_path__ + "static/media/left.910a42c0.svg";